import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityDeliveryFeeQuery, EntityDeliveryFeesApi } from 'api';
import { bankAccountQuery } from 'containers/Branding/Farm/Setting/commons/query';

export const createEntityDeliveryFee = createAsyncThunk(
  'entityDeliveryFee/createEntityDeliveryFee',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityDeliveryFeesApi.create(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityDeliveryFee = createAsyncThunk(
  'entityDeliveryFee/findEntityDeliveryFee',
  async (option: EntityDeliveryFeeQuery, { rejectWithValue }) => {
    try {
      const response = await EntityDeliveryFeesApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityDeliveryFee = createAsyncThunk(
  'entityDeliveryFee/removeEntityDeliveryFee',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityDeliveryFeesApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface Update {
  id: string;
  body: any;
}
export const updateEntityDeliveryFee = createAsyncThunk(
  'entityDeliveryFee/updateEntityDeliveryFee',
  async (params: Update, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityDeliveryFeesApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  tableList: Array<any>;
  orderList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  query: any;
}

const initialState: State = {
  tableList: [],
  orderList: [],
  list: [],
  reloadFlag: false,
  query: bankAccountQuery,
};

const entityDeliveryFeeSlice = createSlice({
  name: 'entityDeliveryFee',
  initialState,
  reducers: {
    reloadEntityDeliveryFee(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder.addCase(findEntityDeliveryFee.fulfilled, (state, action) => {
      const { data } = action.payload;

      state.tableList = data;
    });
  },
});

const { actions, reducer: entityDeliveryFeeReducer } = entityDeliveryFeeSlice;

export const { reloadEntityDeliveryFee } = actions;

export default entityDeliveryFeeReducer;
